const $body = document
const $nav = {
  nav: document.querySelector('.js-st-Header__nav'),
  trigger: document.querySelector('.js-st-Header__navTrigger'),
  inner: document.querySelector('.js-st-Header__navInner')
}

var st;
$nav.trigger.addEventListener('click', function() {

  if($nav.nav.classList.contains('is-show') == true) {
    $nav.nav.classList.remove('is-show');
    document.body.classList.remove('scroll-prevent');
    window.scrollTo({
      behavior: "instant",
      left: 0,
      top: st,
    });

  } else {
    st = window.scrollY;
    $nav.nav.classList.add('is-show');
    document.body.classList.add('scroll-prevent');
  }
});
